/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to login with booking identifier and surname, relies on ReCaptcha to prevent robots from using the service
 * @export
 * @interface PaxCheckStartWithBookingIdAndSurnameRequest
 */
export interface PaxCheckStartWithBookingIdAndSurnameRequest {
    /**
     * Booking id
     * @type {string}
     * @memberof PaxCheckStartWithBookingIdAndSurnameRequest
     */
    bookingId: string;
    /**
     * Passenger surname
     * @type {string}
     * @memberof PaxCheckStartWithBookingIdAndSurnameRequest
     */
    surname: string;
    /**
     * ReCaptcha response
     * @type {string}
     * @memberof PaxCheckStartWithBookingIdAndSurnameRequest
     */
    recaptchaResponse: string;
}

/**
 * Check if a given object implements the PaxCheckStartWithBookingIdAndSurnameRequest interface.
 */
export function instanceOfPaxCheckStartWithBookingIdAndSurnameRequest(value: object): value is PaxCheckStartWithBookingIdAndSurnameRequest {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('recaptchaResponse' in value) || value['recaptchaResponse'] === undefined) return false;
    return true;
}

export function PaxCheckStartWithBookingIdAndSurnameRequestFromJSON(json: any): PaxCheckStartWithBookingIdAndSurnameRequest {
    return PaxCheckStartWithBookingIdAndSurnameRequestFromJSONTyped(json, false);
}

export function PaxCheckStartWithBookingIdAndSurnameRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckStartWithBookingIdAndSurnameRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'surname': json['surname'],
        'recaptchaResponse': json['recaptcha_response'],
    };
}

export function PaxCheckStartWithBookingIdAndSurnameRequestToJSON(json: any): PaxCheckStartWithBookingIdAndSurnameRequest {
    return PaxCheckStartWithBookingIdAndSurnameRequestToJSONTyped(json, false);
}

export function PaxCheckStartWithBookingIdAndSurnameRequestToJSONTyped(value?: PaxCheckStartWithBookingIdAndSurnameRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'surname': value['surname'],
        'recaptcha_response': value['recaptchaResponse'],
    };
}

